import { AtomEffect } from 'recoil'

//resetState时不会调用localStorage.removeItem(key)
export const localStorageWriteStringEffect =
  <T>(key: string): AtomEffect<T> =>
  ({ setSelf, onSet }) => {
    if (typeof window !== 'undefined') {
      onSet((newValue) => {
        localStorage.setItem(key, newValue as string)
      })
    }
  }

export const localStorageWriteJsonEffect =
  <T>(key: string): AtomEffect<T> =>
  ({ setSelf, onSet }) => {
    if (typeof window !== 'undefined') {
      const savedValue = localStorage.getItem(key)
      if (savedValue != null) {
        try {
          setSelf(JSON.parse(savedValue))
        } catch (error) {
          console.error('Failed to parse JSON:', error)
        }
      }

      onSet((newValue, _, isReset) => {
        isReset
          ? localStorage.removeItem(key)
          : localStorage.setItem(key, JSON.stringify(newValue))
      })
    }
  }
